<template>
    <b-container fluid class="mt-3 px-3 pb-2">
        <b-row>
            <b-col cols="" class="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-0">
                            <h2 class="text-left mb-3">{{ $t('maintDashboard.title') }}</h2>
                        </div>
                        <div class="filter-buttons d-flex align-items-center flex-wrap">
                            <span class="filter-label mr-2">{{ $t('maintDashboard.scope') }}</span>
                            <div class="btn-group mr-4">
                                <button v-for="scope in scopeOptions" :key="scope.value"
                                    :class="['filter-btn', { active: selectedScope === scope.value }]"
                                    @click="handleScopeChange(scope.value)">
                                    {{ scope.label }}
                                </button>
                            </div>
                            <span class="filter-label mr-2">{{ $t('maintDashboard.time') }}</span>
                            <div class="btn-group">
                                <button v-for="time in timeOptions" :key="time.value"
                                    :class="['filter-btn', { active: selectedTime === time.value }]"
                                    @click="handleTimeClick(time.value)">
                                    {{ time.label }}
                                </button>
                                <b-form-select v-if="selectedTime === 'custom'" class="filter-btn custom-select-btn ml-2"
                                    :options="[{ value: '', text: $t('maintDashboard.selectPeriod') }, ...getRemainingQuarters()]"
                                    v-model="customDateRange" @change="onCustomDateChange"></b-form-select>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <b-row class="dashboard_total">
            <b-col xl="3" lg="4" md="6" class="px-3 pr-lg-0 mt-3">
                <div class="total_team total_driver d-block h-100 p-4">
                    <p class="mb-1 f-12">{{ $t('maintDashboard.totalRepairs') }}</p>
                    <div>
                        <h5 class="number mb-1">
                            {{ totalRepairs ? totalRepairs : "0" }}
                        </h5>
                        <p class="mb-0 f-14"
                            :style="{ color: totalRepairsPercentage !== 0 ? totalRepairsPercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                            <i v-if="totalRepairsPercentage !== 0" class="fa"
                                :class="totalRepairsPercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"
                                aria-hidden="true"></i>
                            {{
                                `${getFormattedValue(totalRepairsPercentage)}%`
                            }}
                        </p>
                    </div>
                </div>
            </b-col>
            <b-col xl="3" lg="4" md="6" class="px-3 mt-3 pr-xl-0 pr-lg-0">
                <div class="total_team total_driver d-block h-100 p-4">
                    <p class="mb-1 f-12">{{ $t('maintDashboard.totalMiles') }}</p>
                    <div>
                        <h5 class="number mb-1">
                            {{ totalMiles ? `${getAmount(totalMiles)}` : "0.00" }}
                        </h5>
                        <p class="mb-0 f-14"
                            :style="{ color: totalMilesPercentage !== 0 ? totalMilesPercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                            <i v-if="totalMilesPercentage !== 0" class="fa"
                                :class="totalMilesPercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                            {{
                                `${getFormattedValue(totalMilesPercentage)}%`
                            }}
                        </p>
                    </div>
                </div>
            </b-col>
             <b-col  xl="3" lg="4" md="6" class="px-3 pr-xl-0 mt-3">
                <div class="total_team total_driver d-block h-100 p-4">
                    <p class="mb-1 f-12">{{ $t('maintDashboard.costPerMile') }}</p>
                    <div>
                        <h5 class="number mb-1">
                            {{ costPerMile ? `$${getAmount(costPerMile)}` : "$0.00" }}
                        </h5>
                        <p class="mb-0 f-14"
                            :style="{ color: cpmChangePercentage !== 0 ? cpmChangePercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                            <i v-if="cpmChangePercentage !== 0" class="fa"
                                :class="cpmChangePercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                            {{
                                `${getFormattedValue(cpmChangePercentage)}%`
                            }}
                        </p>
                    </div>
                </div>
            </b-col>
            <b-col  xl="3" lg="4" md="6" class="px-3 px-xl-3 pr-lg-0 mt-3">
                <div class="total_team total_driver d-block h-100 p-4">
                    <p class="mb-1 f-12">{{ $t('maintDashboard.totalCost') }}</p>
                    <div>
                        <h5 class="number mb-1">
                            {{ totalAmount ? `$${getAmount(totalAmount)}` : "$0.00" }}
                        </h5>
                        <p class="mb-0 f-14"
                            :style="{ color: totalAmountPercentage !== 0 ? totalAmountPercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                            <i v-if="totalAmountPercentage !== 0" class="fa"
                                :class="totalAmountPercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                            {{
                                `${getFormattedValue(totalAmountPercentage)}%`
                            }}
                        </p>
                    </div>
                </div>
            </b-col>
           
        </b-row>
        <b-row>
            <b-col sm="12">
                <div class="chart-card mt-3">
                    <h5 class="chart-title text-left">{{ $t('maintDashboard.totalRepairCost') }}</h5>
                    <div class="chart-container">
                        <LineChart ref="lineChart" :chart-data="chartData" :chart-options="chartOptions" />
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <div class="table-card mt-3">
                    <h5 class="chart-title text-left">{{ equipmentPerformanceTitle }}</h5>
                    <div class="mt-3">
                        <b-table class="mt-2" responsive :fields="fields" :items="items" hover :current-page="currentPage"
                            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy"
                            :sticky-header="'calc(100vh - 330px)'" :show-empty="emptyTable">
                            <template #cell(total_miles)="data">
                                {{
                                    data.value !== "-" ? `${getAmount(data.value)}` : "-"
                                }}
                            </template> <template #cell(cost_per_mile)="data">
                                {{
                                    data.value !== "-" ? `$${getAmount(data.value)}` : "-"
                                }}
                            </template>
                            <template #cell(total_maintenance_amount)="data">
                                {{
                                    data.value !== "-" ? `$${getAmount(data.value)}` : "-"
                                }}
                            </template>
                            <template #cell(cpm_change_percentage)="data">
                                <span
                                    :style="{ color: data.value !== 0 ? data.value > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                                    <i v-if="data.value !== 0" class="fa"
                                        :class="data.value > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                                    {{
                                        `${getFormattedValue(data.value)}%`
                                    }}
                                </span>
                            </template>
                            <template #cell(amount_change_percentage)="data">
                                <span
                                    :style="{ color: data.value !== 0 ? data.value > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                                    <i v-if="data.value !== 0" class="fa"
                                        :class="data.value > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                                    {{
                                        `${getFormattedValue(data.value)}%`
                                    }}
                                </span>
                            </template>
                            <template v-slot:custom-foot>
                                <tr class="sticky-footer">
                                    <td></td>
                                    <td></td>
                                    <th class="text-right f-14">{{ totalMiles ? `${getAmount(totalMiles)}` : "-" }}</th>
                                    <th class="text-right f-14">{{ costPerMile ? `$${getAmount(costPerMile)}` : "-" }}</th>
                                    <th class="text-right f-14">
                                        <span
                                            :style="{ color: cpmChangePercentage !== 0 ? cpmChangePercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                                            <i v-if="cpmChangePercentage !== 0" class="fa"
                                                :class="cpmChangePercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"
                                                aria-hidden="true"></i>
                                            {{
                                                `${getFormattedValue(cpmChangePercentage)}%`
                                            }}
                                        </span>
                                    </th>
                                    <th class="text-right f-14">{{ totalAmount ? `$${getAmount(totalAmount)}` : "-" }}</th>
                                    <th class="text-right f-14">
                                        <span
                                            :style="{ color: totalAmountPercentage !== 0 ? totalAmountPercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                                            <i v-if="totalAmountPercentage !== 0" class="fa"
                                                :class="totalAmountPercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"
                                                aria-hidden="true"></i>
                                            {{
                                                `${getFormattedValue(totalAmountPercentage)}%`
                                            }}
                                        </span>
                                    </th>
                                </tr>
                            </template>
                        </b-table>
                        <div class="entries-pagination px-0 px-sm-2">
                            <div class="d-flex align-items-center flex-wrap">
                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                </div>
                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                                <div class="pagination">
                                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                        aria-controls="my-table"></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { Line as LineChart } from 'vue-chartjs'
import { mapActions } from "vuex"
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    Filler
)

export default {
    name: "MaintenanceDashboard",
    components: {
        LineChart,
    },
    data() {
        return {
            selectedScope: '',
            selectedTime: 'this_month',
            customDateRange: '',
            items: [],
            rows: 0,
            totalAmount: 0,
            cpmChangePercentage: 0,
            totalMilesPercentage: 0,
            emptyTable: false,
            totalAmountPercentage: 0,
            totalRepairs: 0,
            totalRepairsPercentage: 0,
            totalMiles: 0,
            costPerMile: 0,
            equipmentRepairs: 0,
            equipmentRepairsPercentage: 0,
            currentPage: 1,
            isBusy: false,
            sortBy: undefined,
            sortDesc: undefined,
            perPage: 10,
            positionText: "",
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            fields: [
                {
                    key: "unit_no",
                    label: "Unit #",
                    sortable: true,
                    disabled: true,
                    field: "text",
                    stickyColumn: true,
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
                {
                    key: "type",
                    label: "Type",
                    sortable: true,
                    disabled: true,
                    field: "text",
                    stickyColumn: false,
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
                {
                    key: "total_miles",
                    label: "Total Miles",
                    sortable: true,
                    disabled: true,
                    field: "text",
                    stickyColumn: false,
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
                {
                    key: "cost_per_mile",
                    label: "CPM",
                    sortable: true,
                    disabled: true,
                    field: "text",
                    stickyColumn: false,
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
                {
                    key: "cpm_change_percentage",
                    label: "CPM Change %",
                    sortable: true,
                    disabled: true,
                    field: "text",
                    stickyColumn: false,
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
                {
                    key: "total_maintenance_amount",
                    label: "Total",
                    sortable: true,
                    disabled: false,
                    field: "text",
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
                {
                    key: "amount_change_percentage",
                    label: "Total Change %",
                    sortable: true,
                    disabled: true,
                    field: "text",
                    stickyColumn: false,
                    thClass: 'font-table-weight-bold text-right',
                    tdClass: 'text-right'
                },
            ],
            scopeOptions: [
                { label: 'All', value: '' },
                { label: 'Vehicles', value: 'Vehicle' },
                { label: 'Trailers', value: 'Trailer' }
            ],
            timeOptions: [
                { label: 'This Month', value: 'this_month' },
                { label: 'Last Month', value: 'last_month' },
                { label: 'This Year', value: 'this_year' },
                { label: 'Last Year', value: 'last_year' },
                { label: 'Custom', value: 'custom' }
            ],
            filterFields: {
                date: '',
                type: ''
            },
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Maintenance Cost',
                        data: [],
                        borderColor: '#2D69F6',
                        backgroundColor: (context) => {
                            const chart = context.chart;
                            const { ctx, chartArea } = chart;
                            if (!chartArea) return null;
                            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                            gradient.addColorStop(0, 'rgba(45, 105, 246, 0.2)');
                            gradient.addColorStop(1, 'rgba(45, 105, 246, 0)');
                            return gradient;
                        },
                        borderWidth: 2,
                        tension: 0.4,
                        fill: true,
                        pointRadius: 4,
                        pointBackgroundColor: '#2D69F6',
                        pointBorderColor: '#fff',
                        pointBorderWidth: 2,
                        pointHoverRadius: 6
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                return '$' + context.parsed.y.toLocaleString();
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            color: 'rgba(0, 0, 0, 0.05)'
                        },
                        ticks: {
                            color: '#888'
                        }
                    },
                    y: {
                        grid: {
                            color: 'rgba(0, 0, 0, 0.05)'
                        },
                        ticks: {
                            color: '#888',
                            callback: (value) => {
                                return '$' + value.toLocaleString();
                            }
                        },
                        beginAtZero: true
                    }
                }
            }
        };
    },
    computed: {
        currentDate() {
            return new Date().toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        equipmentPerformanceTitle() {
            return this.$t('maintDashboard.equipmentPerformance');
        }
    },
    watch: {
        perPage: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
        },
        sortBy: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
    },
    methods: {
        ...mapActions(["monthlyMaintenanceTotal", "setLoader", "getMaintenanceTotal"]),
        getFormattedValue(item) {
            return item ? parseFloat(item).toFixed(0) : 0;
        },
        getDateRangeForTimeOption(value) {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();

            const pad = (n) => String(n).padStart(2, "0");
            const lastDayOfMonth = (y, m) => new Date(y, m + 1, 0).getDate();

            switch (value) {
                case 'this_month': {
                    const startDate = `${currentYear}-${pad(currentMonth + 1)}-01`;
                    const endDate = `${currentYear}-${pad(currentMonth + 1)}-${lastDayOfMonth(currentYear, currentMonth)}`;
                    return `start_date=${startDate}&end_date=${endDate}`;
                }
                case 'last_month': {
                    const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
                    const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;
                    const startDate = `${lastMonthYear}-${pad(lastMonth + 1)}-01`;
                    const endDate = `${lastMonthYear}-${pad(lastMonth + 1)}-${lastDayOfMonth(lastMonthYear, lastMonth)}`;
                    return `start_date=${startDate}&end_date=${endDate}`;
                }
                case 'this_year': {
                    return `start_date=${currentYear}-01-01&end_date=${currentYear}-12-31`;
                }
                case 'last_year': {
                    const lastYear = currentYear - 1;
                    return `start_date=${lastYear}-01-01&end_date=${lastYear}-12-31`;
                }
                default:
                    return '';
            }
        },
        handleScopeChange(value) {
            this.selectedScope = value;
            this.filterFields.type = value;
            this.getMaintenanceTotalData();
        },
        handleTimeClick(value) {
            this.selectedTime = value;
            if (value !== 'custom') {
                this.customDateRange = '';
                this.filterFields.date = this.getDateRangeForTimeOption(value);
            }
            this.getMaintenanceTotalData();
        },
        getAmount(val) {
            return parseFloat(val).toLocaleString("en", {
                useGrouping: false,
                minimumFractionDigits: 2,
            });
        },
        onCustomDateChange() {
            // Handle custom date range selection
            this.filterFields.date = this.customDateRange;
            this.getMaintenanceTotalData();
        },
        getRemainingQuarters() {
            const result = [];
            const startYear = 2025;
            const startMonth = 0; // Jan
            const now = new Date();

            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();

            const monthNames = [
                "Jan", "Feb", "Mar",
                "Apr", "May", "Jun",
                "July", "Aug", "Sept",
                "Oct", "Nov", "Dec"
            ];

            const pad = (n) => String(n).padStart(2, "0");

            const lastDayOfMonth = (y, m) =>
                new Date(y, m + 1, 0).getDate();

            for (let year = currentYear; year >= startYear; year--) {

                // ---------- YEAR (always full year) ----------
                result.push({
                    text: `${year}`,
                    value: `start_date=${year}-01-01&end_date=${year}-12-31`,
                });

                for (let q = 4; q >= 1; q--) {
                    const qStart = (q - 1) * 3;
                    const qEnd = qStart + 2;

                    // Skip quarters that haven't started yet (current year only)
                    if (year === currentYear && qStart > currentMonth) continue;

                    // Skip quarters before Jan 2025
                    if (year === startYear && qEnd < startMonth) continue;

                    const qStartDate = `${year}-${pad(qStart + 1)}-01`;
                    const qEndDate = `${year}-${pad(qEnd + 1)}-${lastDayOfMonth(year, qEnd)}`;

                    // ---------- QUARTER ----------
                    result.push({
                        text: `${year} Q${q}`,
                        value: `start_date=${qStartDate}&end_date=${qEndDate}`,
                    });

                    // ---------- MONTHS ----------
                    for (let m = qEnd; m >= qStart; m--) {

                        // Future months (current year)
                        if (year === currentYear && m > currentMonth) continue;

                        // Before Jan 2025
                        if (year === startYear && m < startMonth) continue;

                        const mStart = `${year}-${pad(m + 1)}-01`;
                        const mEnd = `${year}-${pad(m + 1)}-${lastDayOfMonth(year, m)}`;

                        result.push({
                            text: `${year} ${monthNames[m]}`,
                            value: `start_date=${mStart}&end_date=${mEnd}`,
                        });
                    }
                }
            }

            return result;
        },
        async getMonthlyMaintenanceTotal() {
            try {
                const data = await this.monthlyMaintenanceTotal()

                // Format month labels and extract amounts
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

                const labels = data.map(item => {
                    const [year, month] = item.month.split('-');
                    return `${monthNames[parseInt(month) - 1]} ${year}`;
                });

                const amounts = data.map(item => item.total_amount);

                // Update chart data
                this.chartData = {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Maintenance Cost',
                            data: amounts,
                            borderColor: '#2D69F6',
                            backgroundColor: (context) => {
                                const chart = context.chart;
                                const { ctx, chartArea } = chart;
                                if (!chartArea) return null;
                                const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                                gradient.addColorStop(0, 'rgba(45, 105, 246, 0.2)');
                                gradient.addColorStop(1, 'rgba(45, 105, 246, 0)');
                                return gradient;
                            },
                            borderWidth: 2,
                            tension: 0.4,
                            fill: true,
                            pointRadius: 4,
                            pointBackgroundColor: '#2D69F6',
                            pointBorderColor: '#fff',
                            pointBorderWidth: 2,
                            pointHoverRadius: 6
                        }
                    ]
                };
            }
            catch (e) {
                console.log(e)
            }
        },
        async getMaintenanceTotalData() {
            try {
                this.isBusy = true
                this.setLoader(true)
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (key === 'date') {
                        url += `${this.filterFields[key]}&`
                    }
                    else if (this.filterFields[key] !== '' && key !== 'tags' && key !== 'date') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=unit_no&sort_order=asc&dashboard=true&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getMaintenanceTotal(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    this.positionText = `${this.currentPage === 1 ? `1` : `${(this.perPage * (this.currentPage - 1)) + 1}`} - ${this.perPage * (this.currentPage - 1) + data.queryset_count} of ${data.total_entries}`
                }
                else {
                    this.rows = 0
                    this.positionText = `0 - 0 of 0`
                }
                this.totalAmount = data.total_amount
                this.costPerMile = data.cost_per_mile
                this.totalMiles = data.total_miles
                this.equipmentRepairs = data.equipment_repairs
                this.totalRepairs = data.total_repairs
                this.cpmChangePercentage = data.cost_per_mile_change_percentage != null ? Number(data.cost_per_mile_change_percentage) : 0
                this.totalAmountPercentage = data.total_amount_change_percentage != null ? Number(data.total_amount_change_percentage) : 0
                this.totalMilesPercentage = data.total_miles_change_percentage != null ? Number(data.total_miles_change_percentage) : 0
                this.equipmentRepairsPercentage = data.equipment_repairs_change_percentage != null ? Number(data.equipment_repairs_change_percentage) : 0
                this.totalRepairsPercentage = data.total_repairs_change_percentage != null ? Number(data.total_repairs_change_percentage) : 0
                this.items = [];
                data.records.forEach(async (m, id) => {
                    this.items.push({
                        id: id,
                        pk: m.id,
                        unit_no: m.unit_no,
                        total_miles: m.total_miles,
                        cost_per_mile: m.cost_per_mile ? m.cost_per_mile : "0.00",
                        type: m.type,
                        total_maintenance_amount: m.total_maintenance_amount,
                        amount_change_percentage: m.amount_change_percentage != null ? Number(m.amount_change_percentage) : 0,
                        cpm_change_percentage: m.cpm_change_percentage != null ? Number(m.cpm_change_percentage) : 0,
                    });
                });
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.setLoader(false)
            }
            catch (e) {
                this.isBusy = false
                this.setLoader(false)
                console.log(e)
            }
        },

    },
    async mounted() {
        try {
            this.setLoader(true)
            await this.getMonthlyMaintenanceTotal()
            this.setLoader(false)
        }
        catch (e) {
            this.setLoader(false)
        }
    },
};
</script>

<style scoped>
.filter-buttons {
    margin-bottom: 10px;
}

.filter-label {
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.btn-group {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.filter-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    background-color: #E8EEF8;
    color: #2D3E5F;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    width: fit-content;
}

.filter-btn:hover {
    background-color: #d0ddf0;
}

.filter-btn.active {
    background-color: #2D69F6;
    color: #fff;
}

.custom-select-btn {
    padding: 8px 12px;
    border-radius: 20px;
    background-color: #E8EEF8;
    color: #2D3E5F;
    font-size: 14px;
    font-weight: 500;
    border: none;
    min-width: 150px;
    cursor: pointer;
}

.custom-select-btn:focus {
    outline: none;
    box-shadow: none;
    border: none;
}

.chart-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    border: 1px solid #dee2e6;
    box-shadow: 0 4px 50px rgb(0 0 0 / 10%);
}

.table-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #dee2e6;
    box-shadow: 0 4px 50px rgb(0 0 0 / 10%);

}

.chart-title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
}

.chart-container {
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
}
</style>